export const DASHBOARD_THEMES = {
    "fca-dash-theme": { accent: "#0087ff" },
    "asset-dash-theme": { accent: "#0d97b8" },
    "mobile-asset-dash-theme": { accent: "#5b5bd6" }
};

export const DEFAULT_DASHBOARD_THEME = "fca-dash-theme";

const clamp = (value, min = 0, max = 255) => Math.min(max, Math.max(min, value));

const hexToRgb = hex => {
    const normalized = hex.replace("#", "");
    const full =
        normalized.length === 3
            ? normalized
                  .split("")
                  .map(char => char + char)
                  .join("")
            : normalized;
    return {
        r: parseInt(full.slice(0, 2), 16),
        g: parseInt(full.slice(2, 4), 16),
        b: parseInt(full.slice(4, 6), 16)
    };
};

const rgbToHex = ({ r, g, b }) => `#${[r, g, b].map(channel => clamp(Math.round(channel)).toString(16).padStart(2, "0")).join("")}`;

const shade = (hex, amount) => {
    const { r, g, b } = hexToRgb(hex);
    const target = amount > 0 ? 255 : 0;
    const ratio = Math.abs(amount);
    return rgbToHex({
        r: r + (target - r) * ratio,
        g: g + (target - g) * ratio,
        b: b + (target - b) * ratio
    });
};

const luminance = hex => {
    const { r, g, b } = hexToRgb(hex);
    const channel = value => {
        const scaled = value / 255;
        return scaled <= 0.03928 ? scaled / 12.92 : Math.pow((scaled + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
};

const contrastColor = hex => (luminance(hex) > 0.45 ? "#1f2354" : "#ffffff");

export const buildThemeTokens = accent => ({
    "--dash-accent": accent,
    "--dash-accent-hover": shade(accent, -0.16),
    "--dash-accent-soft": shade(accent, 0.86),
    "--dash-accent-soft-hover": shade(accent, 0.76),
    "--dash-accent-text": shade(accent, -0.24),
    "--dash-accent-border": shade(accent, 0.62),
    "--dash-accent-contrast": contrastColor(accent),
    "--dash-icon-gradient": `linear-gradient(180deg, ${accent} 0%, ${shade(accent, 0.34)} 100%)`
});

export const getThemeAccent = theme => (DASHBOARD_THEMES[theme] || DASHBOARD_THEMES[DEFAULT_DASHBOARD_THEME]).accent;

export const applyDashboardTheme = (theme, element = document.documentElement) => {
    if (!element) return;
    const tokens = buildThemeTokens(getThemeAccent(theme));
    Object.entries(tokens).forEach(([name, value]) => element.style.setProperty(name, value));
    element.setAttribute("data-dashboard-theme", theme || DEFAULT_DASHBOARD_THEME);
};
